// Add your custom JS here.
(function ($) {

	$(document).on('click', ".forminator-pagination-footer .step-two", function(e){
		e.preventDefault();
		$(".forminator-pagination-footer #forminator-submit").removeClass('step-two');
		
		var address = $("input[type='radio'][name='radio-1']:checked").parent().find('.forminator-radio-label').html();
		var image = $("input[type='radio'][name='radio-1']:checked").next().next().next().find('span').css('background-image');
		var bgimage = image.replace('url(','').replace(')','').replace(/\"/gi, "");
		
		if( $('body').hasClass('page-get-a-valuation') ){
			var value = $("[name=text-1]").val();
			var contactform = $(".contact-form").find("form").find("[data-step=2]");
		}else{
			var value = $("[name=hidden-1]").val();
			var contactform = $(".contact-form").find("form").find("[data-step=1]");
		}
		contactform.prepend('<div class="summary"><img src="'+ bgimage +'" ><div class="form-details"><div class="address"><b>Address</b>: '+ value +'</div><div class="property-type"><b>Property Type</b>: '+ address +'</div></div></div>');
	});

	$(document).on('click', '.forminator-pagination-footer .forminator-button-back', function(){
		$(".forminator-pagination .summary").remove();
	});

	//SHARING
	var screenWidth = window.innerWidth;
	var screenHeight = window.innerHeight;

	var w = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
	var h = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

	var left = ((screenWidth / 2) - 300);
	var top = ((screenHeight / 2) - 150);

	$('.fbsharelink').click(function() {
	    var shareurl = $(this).data('shareurl');
	    window.open('https://www.facebook.com/sharer/sharer.php?u='+escape(shareurl)+'&t='+document.title, '',
	    'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600');
	    return false;
	});
	
	$('.twsharelink').click(function() {
	    var twshareurl = $(this).data('shareurl');
	    var twsharetitle = $(this).data('sharetitle');
	    window.open('http://twitter.com/share?text='+twsharetitle+'&url='+twshareurl+'', '_blank', 'width=600,height=300,top='+top+',left'+left+'');
	    return false;
	});

	$('.lisharelink').click(function() {
	    var lishareurl = $(this).data('shareurl');
	    var lisharetitle = $(this).data('sharetitle');
	    window.open('https://www.linkedin.com/shareArticle?mini=true&url='+lishareurl+'&title='+lisharetitle+'&source=AandS&target=new', '_blank', 'width=600,height=300,top='+ top +',left='+ left +'');
	    return false;
	});

})(jQuery);